import { P2GBox } from '@parcel2go/core-ui';
import { ReactNode } from 'react';
const ActionBar: React.FC<{ isXs: boolean; className: string; children: ReactNode; fullWidth?: boolean }> = (props) => {
  return (
    <P2GBox
      textAlign="center"
      sx={(t) => ({
        backgroundColor: 'white',
        boxShadow: `0 0 10px 5px ${t.palette.grey.A200}`,
        position: props.isXs ? 'fixed' : 'sticky',
        width: '100%',
        left: 0,
        bottom: props.isXs ? 0 : t.spacing(1),
        zIndex: 2,
        borderRadius: props.isXs ? 0 : t.spacing(2),
        marginTop: props.isXs ? 0 : t.spacing(2)
      })}
    >
      {props.isXs ? (
        <>{props.children}</>
      ) : (
        <P2GBox sx={{ display: props.fullWidth ? 'flex' : 'inline-flex', justifyContent: 'center' }}>
          {props.children}
        </P2GBox>
      )}
    </P2GBox>
  );
};

export default ActionBar;
